// extracted by mini-css-extract-plugin
export default {"button":"MyButton_button__Q5rD+","buttonWithIcon":"MyButton_buttonWithIcon__cWYP4"};